// // src/components/OrderList/useOrdersManager.js

// import { useEffect, useMemo, useState } from "react";
// import {
//   collection,
//   getDocs,
//   doc,
//   updateDoc,
//   serverTimestamp,
// } from "firebase/firestore";
// import { db } from "../../../firebase";

// import { STATUS_OPTIONS, TTN_REQUIRED_STATUSES } from "./constants";
// import {
//   parseChoice,
//   getStatus,
//   getTtn,
//   ts,
//   dayStart,
//   dayEnd,
// } from "./orderUtils";

// export function useOrdersManager(initialPageSize = 10) {
//   const [orders, setOrders] = useState([]); // [{ order, choice }]
//   const [expanded, setExpanded] = useState({});

//   // status edit
//   const [editingStatusId, setEditingStatusId] = useState(null);
//   const [statusDraft, setStatusDraft] = useState("");

//   // ttn edit
//   const [editingTtnId, setEditingTtnId] = useState(null);
//   const [ttnDraft, setTtnDraft] = useState("");

//   // filters/sort
//   const [sortDir, setSortDir] = useState("desc");
//   const [statusPin, setStatusPin] = useState("Усі");
//   const [statusOnly, setStatusOnly] = useState(false);
//   const [dateFrom, setDateFrom] = useState("");
//   const [dateTo, setDateTo] = useState("");

//   // paging
//   const [page, setPage] = useState(1);
//   const [pageSize, setPageSize] = useState(initialPageSize);

//   useEffect(() => {
//     (async () => {
//       try {
//         const snap = await getDocs(collection(db, "orders"));
//         const rows = [];
//         snap.forEach((d) => {
//           const raw = { id: d.id, ...d.data() };
//           rows.push({ order: raw, choice: parseChoice(raw?.choice) });
//         });
//         setOrders(rows);
//       } catch (e) {
//         console.error("OrderList load error:", e);
//         setOrders([]);
//       }
//     })();
//   }, []);

//   useEffect(() => {
//     setPage(1);
//   }, [
//     pageSize,
//     sortDir,
//     statusPin,
//     statusOnly,
//     dateFrom,
//     dateTo,
//     orders.length,
//   ]);

//   const toggleExpand = (id) => setExpanded((s) => ({ ...s, [id]: !s[id] }));

//   const filtered = useMemo(() => {
//     let arr = [...orders];

//     if (statusOnly && statusPin !== "Усі") {
//       arr = arr.filter(({ order }) => getStatus(order) === statusPin);
//     }

//     if (dateFrom || dateTo) {
//       const fromMs = dateFrom ? dayStart(dateFrom) : -Infinity;
//       const toMs = dateTo ? dayEnd(dateTo) : Infinity;
//       arr = arr.filter(({ order }) => {
//         const t = ts(order);
//         return t >= fromMs && t <= toMs;
//       });
//     }

//     return arr;
//   }, [orders, statusOnly, statusPin, dateFrom, dateTo]);

//   const sorted = useMemo(() => {
//     const arr = [...filtered];

//     const cmpDate = (a, b) => {
//       const A = ts(a.order);
//       const B = ts(b.order);
//       return sortDir === "asc" ? A - B : B - A;
//     };

//     if (statusPin !== "Усі" && !statusOnly) {
//       arr.sort((a, b) => {
//         const pa = getStatus(a.order) === statusPin ? 0 : 1;
//         const pb = getStatus(b.order) === statusPin ? 0 : 1;
//         if (pa !== pb) return pa - pb;
//         return cmpDate(a, b);
//       });
//     } else {
//       arr.sort(cmpDate);
//     }

//     return arr;
//   }, [filtered, sortDir, statusPin, statusOnly]);

//   const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
//   const pageClamped = Math.min(page, totalPages);
//   const start = (pageClamped - 1) * pageSize;
//   const end = start + pageSize;
//   const paged = sorted.slice(start, end);

//   const goto = (p) => setPage(Math.min(Math.max(1, p), totalPages));

//   // ===== STATUS =====
//   const beginEditStatus = (order, e) => {
//     e?.stopPropagation?.();
//     setEditingStatusId(order.id);
//     setStatusDraft(getStatus(order));
//   };

//   const cancelEditStatus = () => {
//     setEditingStatusId(null);
//     setStatusDraft("");
//   };

//   const saveStatusToDb = async (orderId, nextStatusRaw) => {
//     const nextStatus =
//       String(nextStatusRaw || "").trim() || "Очікує підтвердження";

//     const row = orders.find((r) => r.order.id === orderId);
//     const currentOrder = row?.order || {};
//     const currentTtn = getTtn(currentOrder);

//     if (
//       TTN_REQUIRED_STATUSES.has(nextStatus) &&
//       !String(currentTtn || "").trim()
//     ) {
//       alert("Спочатку внесіть номер ТТН Нової пошти, потім змініть статус.");
//       return;
//     }

//     const canceled = nextStatus === "Скасовано";
//     const nowISO = new Date().toISOString();

//     await updateDoc(doc(db, "orders", orderId), {
//       status: nextStatus,
//       canceled,
//       updatedAt: serverTimestamp(),
//       updatedAtISO: nowISO,
//       statusFlow: { current: nextStatus, updatedAtISO: nowISO },
//     });

//     setOrders((arr) =>
//       arr.map((r) =>
//         r.order.id === orderId
//           ? {
//               ...r,
//               order: {
//                 ...r.order,
//                 status: nextStatus,
//                 canceled,
//                 updatedAtISO: nowISO,
//                 statusFlow: {
//                   ...(r.order?.statusFlow || {}),
//                   current: nextStatus,
//                   updatedAtISO: nowISO,
//                 },
//               },
//             }
//           : r,
//       ),
//     );
//   };

//   const saveStatus = async (orderId) => {
//     await saveStatusToDb(orderId, statusDraft);
//     cancelEditStatus();
//   };

//   const onStatusKey = (e, orderId) => {
//     if (e.key === "Enter") saveStatus(orderId);
//     if (e.key === "Escape") cancelEditStatus();
//   };

//   // ===== TTN =====
//   const beginEditTTN = (order) => {
//     setEditingTtnId(order.id);
//     setTtnDraft(String(getTtn(order) || ""));
//   };

//   const cancelEditTTN = () => {
//     setEditingTtnId(null);
//     setTtnDraft("");
//   };

//   const saveTTNToDb = async (orderId, ttnValue, options = {}) => {
//     const normalized = String(ttnValue || "")
//       .replace(/\D/g, "")
//       .trim();
//     if (!/^\d{8,14}$/.test(normalized)) {
//       alert("Введіть коректний номер ТТН (8–14 цифр).");
//       return;
//     }

//     const row = orders.find((r) => r.order.id === orderId);
//     const currentOrder = row?.order || {};
//     const currentStatus = getStatus(currentOrder);
//     const nextStatus = options.setStatusAfterSave
//       ? "ТТН НП внесено"
//       : currentStatus;

//     const nowISO = new Date().toISOString();

//     await updateDoc(doc(db, "orders", orderId), {
//       ttn: normalized,
//       status: nextStatus,
//       updatedAt: serverTimestamp(),
//       updatedAtISO: nowISO,
//       delivery: { ...(currentOrder?.delivery || {}), ttn: normalized },
//       logistics: {
//         ...(currentOrder?.logistics || {}),
//         provider: "Нова пошта",
//         providerLabel: "Нова пошта",
//         ttn: normalized,
//         updatedAtISO: nowISO,
//       },
//     });

//     setOrders((arr) =>
//       arr.map((r) => {
//         if (r.order.id !== orderId) return r;
//         return {
//           ...r,
//           order: {
//             ...r.order,
//             ttn: normalized,
//             status: nextStatus,
//             updatedAtISO: nowISO,
//             delivery: { ...(r.order?.delivery || {}), ttn: normalized },
//             logistics: {
//               ...(r.order?.logistics || {}),
//               provider: "Нова пошта",
//               providerLabel: "Нова пошта",
//               ttn: normalized,
//               updatedAtISO: nowISO,
//             },
//           },
//         };
//       }),
//     );
//   };

//   const saveTTN = async (orderId) => {
//     await saveTTNToDb(orderId, ttnDraft, { setStatusAfterSave: false });
//     cancelEditTTN();
//   };

//   const saveTTNAndSetStatus = async (orderId) => {
//     await saveTTNToDb(orderId, ttnDraft, { setStatusAfterSave: true });
//     cancelEditTTN();
//   };

//   const onTtnKey = (e, orderId) => {
//     if (e.key === "Enter") saveTTN(orderId);
//     if (e.key === "Escape") cancelEditTTN();
//   };

//   return {
//     orders,
//     paged,
//     expanded,
//     toggleExpand,

//     // filters
//     sortDir,
//     setSortDir,
//     statusPin,
//     setStatusPin,
//     statusOnly,
//     setStatusOnly,
//     dateFrom,
//     setDateFrom,
//     dateTo,
//     setDateTo,

//     // paging
//     pageSize,
//     setPageSize,
//     totalPages,
//     pageClamped,
//     goto,

//     // status
//     editingStatusId,
//     statusDraft,
//     setStatusDraft,
//     beginEditStatus,
//     saveStatus,
//     cancelEditStatus,
//     onStatusKey,

//     // ttn
//     editingTtnId,
//     ttnDraft,
//     setTtnDraft,
//     beginEditTTN,
//     saveTTN,
//     saveTTNAndSetStatus,
//     cancelEditTTN,
//     onTtnKey,

//     STATUS_OPTIONS,
//   };
// }
// src/components/OrderList/useOrdersManager.js

import { useEffect, useMemo, useState } from "react";
import {
  collection,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../../firebase";

import { STATUS_OPTIONS, TTN_REQUIRED_STATUSES } from "./constants";
import {
  parseChoice,
  getStatus,
  getTtn,
  ts,
  dayStart,
  dayEnd,
  getItemFinalUnitPrice,
} from "./orderUtils";

export function useOrdersManager(initialPageSize = 10) {
  const [orders, setOrders] = useState([]); // [{ order, choice }]
  const [expanded, setExpanded] = useState({});

  // status edit
  const [editingStatusId, setEditingStatusId] = useState(null);
  const [statusDraft, setStatusDraft] = useState("");

  // ttn edit
  const [editingTtnId, setEditingTtnId] = useState(null);
  const [ttnDraft, setTtnDraft] = useState("");
  // ===== ITEMS EDIT =====
  const [editingItemsId, setEditingItemsId] = useState(null);
  const [itemsDraft, setItemsDraft] = useState([]);
  const [newPid, setNewPid] = useState("");
  const [newQty, setNewQty] = useState(1);
  const [savingItems, setSavingItems] = useState(false);
  // filters/sort
  const [sortDir, setSortDir] = useState("desc");
  const [statusPin, setStatusPin] = useState("Усі");
  const [statusOnly, setStatusOnly] = useState(false);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");

  // paging
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const buildRow = (docSnapOrId, dataMaybe) => {
    // варіант 1: коли передаємо snap (getDoc)
    if (docSnapOrId?.exists && docSnapOrId.exists()) {
      const raw = { id: docSnapOrId.id, ...docSnapOrId.data() };
      return { order: raw, choice: parseChoice(raw?.choice) };
    }

    // варіант 2: коли передаємо id+data
    const id = String(docSnapOrId || "");
    const raw = { id, ...(dataMaybe || {}) };
    return { order: raw, choice: parseChoice(raw?.choice) };
  };
  const loadOrders = async () => {
    const snap = await getDocs(collection(db, "orders"));
    const rows = [];
    snap.forEach((d) => {
      rows.push(buildRow(d));
    });
    setOrders(rows);
  };
  const reloadOneOrder = async (orderId) => {
    const ref = doc(db, "orders", String(orderId));
    const snap = await getDoc(ref);

    if (!snap.exists()) return;

    const updatedRow = buildRow(snap);

    setOrders((arr) =>
      arr.map((r) => (r.order.id === orderId ? updatedRow : r)),
    );
  };
  useEffect(() => {
    (async () => {
      try {
        await loadOrders();
      } catch (e) {
        console.error("OrderList load error:", e);
        setOrders([]);
      }
    })();
  }, []);

  useEffect(() => {
    setPage(1);
  }, [
    pageSize,
    sortDir,
    statusPin,
    statusOnly,
    dateFrom,
    dateTo,
    orders.length,
  ]);

  const toggleExpand = (id) => setExpanded((s) => ({ ...s, [id]: !s[id] }));

  const filtered = useMemo(() => {
    let arr = [...orders];

    if (statusOnly && statusPin !== "Усі") {
      arr = arr.filter(({ order }) => getStatus(order) === statusPin);
    }

    if (dateFrom || dateTo) {
      const fromMs = dateFrom ? dayStart(dateFrom) : -Infinity;
      const toMs = dateTo ? dayEnd(dateTo) : Infinity;
      arr = arr.filter(({ order }) => {
        const t = ts(order);
        return t >= fromMs && t <= toMs;
      });
    }

    return arr;
  }, [orders, statusOnly, statusPin, dateFrom, dateTo]);

  const sorted = useMemo(() => {
    const arr = [...filtered];

    const cmpDate = (a, b) => {
      const A = ts(a.order);
      const B = ts(b.order);
      return sortDir === "asc" ? A - B : B - A;
    };

    if (statusPin !== "Усі" && !statusOnly) {
      arr.sort((a, b) => {
        const pa = getStatus(a.order) === statusPin ? 0 : 1;
        const pb = getStatus(b.order) === statusPin ? 0 : 1;
        if (pa !== pb) return pa - pb;
        return cmpDate(a, b);
      });
    } else {
      arr.sort(cmpDate);
    }

    return arr;
  }, [filtered, sortDir, statusPin, statusOnly]);

  const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
  const pageClamped = Math.min(page, totalPages);
  const start = (pageClamped - 1) * pageSize;
  const end = start + pageSize;
  const paged = sorted.slice(start, end);

  const goto = (p) => setPage(Math.min(Math.max(1, p), totalPages));

  // ===== STATUS =====
  const beginEditStatus = (order, e) => {
    e?.stopPropagation?.();
    setEditingStatusId(order.id);
    setStatusDraft(getStatus(order));
  };

  const cancelEditStatus = () => {
    setEditingStatusId(null);
    setStatusDraft("");
  };

  const saveStatusToDb = async (orderId, nextStatusRaw) => {
    const nextStatus =
      String(nextStatusRaw || "").trim() || "Очікує підтвердження";

    const row = orders.find((r) => r.order.id === orderId);
    const currentOrder = row?.order || {};
    const currentTtn = getTtn(currentOrder);

    if (
      TTN_REQUIRED_STATUSES.has(nextStatus) &&
      !String(currentTtn || "").trim()
    ) {
      alert("Спочатку внесіть номер ТТН Нової пошти, потім змініть статус.");
      return;
    }

    const canceled = nextStatus === "Скасовано";
    const nowISO = new Date().toISOString();

    await updateDoc(doc(db, "orders", orderId), {
      status: nextStatus,
      canceled,
      updatedAt: serverTimestamp(),
      updatedAtISO: nowISO,
      statusFlow: { current: nextStatus, updatedAtISO: nowISO },
    });

    setOrders((arr) =>
      arr.map((r) =>
        r.order.id === orderId
          ? {
              ...r,
              order: {
                ...r.order,
                status: nextStatus,
                canceled,
                updatedAtISO: nowISO,
                statusFlow: {
                  ...(r.order?.statusFlow || {}),
                  current: nextStatus,
                  updatedAtISO: nowISO,
                },
              },
            }
          : r,
      ),
    );
  };

  const saveStatus = async (orderId) => {
    await saveStatusToDb(orderId, statusDraft);
    cancelEditStatus();
  };

  const onStatusKey = (e, orderId) => {
    if (e.key === "Enter") saveStatus(orderId);
    if (e.key === "Escape") cancelEditStatus();
  };

  // ===== TTN =====
  const beginEditTTN = (order) => {
    setEditingTtnId(order.id);
    setTtnDraft(String(getTtn(order) || ""));
  };

  const cancelEditTTN = () => {
    setEditingTtnId(null);
    setTtnDraft("");
  };

  const saveTTNToDb = async (orderId, ttnValue, options = {}) => {
    const normalized = String(ttnValue || "")
      .replace(/\D/g, "")
      .trim();
    if (!/^\d{8,14}$/.test(normalized)) {
      alert("Введіть коректний номер ТТН (8–14 цифр).");
      return;
    }

    const row = orders.find((r) => r.order.id === orderId);
    const currentOrder = row?.order || {};
    const currentStatus = getStatus(currentOrder);
    const nextStatus = options.setStatusAfterSave
      ? "ТТН НП внесено"
      : currentStatus;

    const nowISO = new Date().toISOString();

    await updateDoc(doc(db, "orders", orderId), {
      ttn: normalized,
      status: nextStatus,
      updatedAt: serverTimestamp(),
      updatedAtISO: nowISO,
      delivery: { ...(currentOrder?.delivery || {}), ttn: normalized },
      logistics: {
        ...(currentOrder?.logistics || {}),
        provider: "Нова пошта",
        providerLabel: "Нова пошта",
        ttn: normalized,
        updatedAtISO: nowISO,
      },
    });

    setOrders((arr) =>
      arr.map((r) => {
        if (r.order.id !== orderId) return r;
        return {
          ...r,
          order: {
            ...r.order,
            ttn: normalized,
            status: nextStatus,
            updatedAtISO: nowISO,
            delivery: { ...(r.order?.delivery || {}), ttn: normalized },
            logistics: {
              ...(r.order?.logistics || {}),
              provider: "Нова пошта",
              providerLabel: "Нова пошта",
              ttn: normalized,
              updatedAtISO: nowISO,
            },
          },
        };
      }),
    );
  };

  const saveTTN = async (orderId) => {
    await saveTTNToDb(orderId, ttnDraft, { setStatusAfterSave: false });
    cancelEditTTN();
  };

  const saveTTNAndSetStatus = async (orderId) => {
    await saveTTNToDb(orderId, ttnDraft, { setStatusAfterSave: true });
    cancelEditTTN();
  };

  const onTtnKey = (e, orderId) => {
    if (e.key === "Enter") saveTTN(orderId);
    if (e.key === "Escape") cancelEditTTN();
  };
  // ===== ITEMS EDIT LOGIC =====
  const beginEditItems = (rowOrOrder) => {
    const order = rowOrOrder?.order ? rowOrOrder.order : rowOrOrder;

    const ch = parseChoice(order?.choice);

    const normalized = (Array.isArray(ch) ? ch : []).map((it, idx) => {
      const quantity = Math.max(1, Number(it?.quantity ?? it?.qty ?? 1) || 1);
      const realUnitPrice = getItemFinalUnitPrice(it);

      const rawBasePrice = Number(it?.basePrice);
      const rawPrice = Number(it?.price);

      const basePrice =
        Number.isFinite(rawBasePrice) && rawBasePrice > 0
          ? rawBasePrice
          : Number.isFinite(rawPrice) && rawPrice > realUnitPrice
            ? rawPrice
            : realUnitPrice;

      const rawLineTotal = Number(it?.lineTotal);
      const lineTotal =
        Number.isFinite(rawLineTotal) && rawLineTotal > 0
          ? rawLineTotal
          : Number((realUnitPrice * quantity).toFixed(2));

      return {
        ...it,
        __key: `${it.uid || it.id || it.productId || "x"}-${idx}`,
        isNew: false,
        quantity,

        // важливо для бекенду при повторному збереженні
        price: realUnitPrice,
        finalPrice: realUnitPrice,
        unitPrice: realUnitPrice,
        purchasedUnitPrice:
          Number(it?.purchasedUnitPrice) > 0
            ? Number(it.purchasedUnitPrice)
            : realUnitPrice,

        basePrice,
        lineTotal,
      };
    });

    setEditingItemsId(order.id);
    setExpanded((s) => ({ ...s, [order.id]: true }));
    setItemsDraft(normalized);
    setNewPid("");
    setNewQty(1);
  };

  const cancelEditItems = () => {
    setEditingItemsId(null);
    setItemsDraft([]);
    setNewPid("");
    setNewQty(1);
    setSavingItems(false);
  };

  const setItemQty = (__key, qty) => {
    const q = Math.max(1, Number(qty) || 1);
    setItemsDraft((arr) =>
      arr.map((it) => (it.__key === __key ? { ...it, quantity: q } : it)),
    );
  };

  const removeDraftItem = (__key) => {
    setItemsDraft((arr) => arr.filter((it) => it.__key !== __key));
  };

  // опціонально: якщо додаєш той самий productId — просто збільшуємо кількість
  const addDraftItem = (product, qty = 1) => {
    const pid = String(product?.id || "").trim();
    if (!pid) return;

    const q = Math.max(1, Number(qty) || 1);

    const title = product?.bookName || product?.name || `ID: ${pid}`;

    setItemsDraft((arr) => {
      const existsIdx = arr.findIndex(
        (x) => String(x.productId || x.id || x.uid || "").trim() === pid,
      );

      // якщо вже є в чернетці — додаємо кількість
      if (existsIdx !== -1) {
        return arr.map((x, i) =>
          i === existsIdx ? { ...x, quantity: (x.quantity || 1) + q } : x,
        );
      }

      // новий рядок — isNew:true (бекенд перерахує ціну)
      return [
        ...arr,
        {
          __key: `new-${Date.now()}-${Math.random()}`,
          productId: pid,
          id: pid,
          uid: pid,
          quantity: q,
          isNew: true,

          name: title,
          bookName: title,

          // можна додати прев’ю, щоб було красиво
          imageList: Array.isArray(product?.imageList) ? product.imageList : [],
          images: Array.isArray(product?.images) ? product.images : [],
          textAutor: product?.textAutor || "",
          seria: product?.seria || product?.series || "",
        },
      ];
    });
  };

  const saveItems = async (orderId, paymentMethodRaw) => {
    if (savingItems) return null;
    setSavingItems(true);

    try {
      const backend = "http://localhost:4000";

      const payload = {
        orderId,
        items: itemsDraft.map(({ __key, ...it }) => ({
          ...it,
          // гарантуємо, що quantity число
          quantity: Math.max(1, Number(it.quantity || 1) || 1),
        })),
      };

      const resp = await fetch(`${backend}/admin/order/update-items`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const json = await resp.json();
      if (!resp.ok) throw new Error(json?.error || "Save failed");

      // КЛЮЧ: перечитуємо order з Firestore (щоб побачити правильні ціни/лінки)
      await reloadOneOrder(orderId);

      cancelEditItems();
      return json;
    } finally {
      setSavingItems(false);
    }
  };
  return {
    orders,
    paged,
    expanded,
    toggleExpand,

    // filters
    sortDir,
    setSortDir,
    statusPin,
    setStatusPin,
    statusOnly,
    setStatusOnly,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,

    // paging
    pageSize,
    setPageSize,
    totalPages,
    pageClamped,
    goto,

    // status
    editingStatusId,
    statusDraft,
    setStatusDraft,
    beginEditStatus,
    saveStatus,
    cancelEditStatus,
    onStatusKey,

    // ttn
    editingTtnId,
    ttnDraft,
    setTtnDraft,
    beginEditTTN,
    saveTTN,
    saveTTNAndSetStatus,
    cancelEditTTN,
    onTtnKey,
    // items edit
    editingItemsId,
    itemsDraft,
    newPid,
    setNewPid,
    newQty,
    setNewQty,
    savingItems,
    beginEditItems,
    cancelEditItems,
    setItemQty,
    removeDraftItem,
    addDraftItem,
    saveItems,
    STATUS_OPTIONS,
  };
}
